import { Pog, PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { cloneDeep, isEqual } from "es-toolkit";
import { PrimitiveAtom, useAtom } from "jotai";
import { useState } from "react";
import { useModals } from "src/components/Modals";

export const useModifiedPog = (pogAtom: PrimitiveAtom<Pog | null>) => {
  const { openConfirmModal } = useModals();
  const [pog, _setPog] = useAtom(pogAtom);
  const [originalPog, setOrignalPog] = useState<Pog | null>(null);

  const setPog = (pog: PogNonCircular | null) => {
    if (!pog) {
      _setPog(null);
      setOrignalPog(null);
      return;
    }
    setOrignalPog(cloneDeep(new Pog(pog)));
    _setPog(new Pog(pog));
  };

  const revertPog = () => {
    openConfirmModal({
      title: "Revert modified planogram changes?",
      description: "All unsaved changes made to the planogram will be lost. This is irreversible.",
      buttons: [
        {
          id: "keep-changes",
          label: "Keep Changes",
          color: "primary",
          variant: "inverted",
        },
        {
          id: "revert-changes",
          label: "Revert Changes",
          color: "red",
          onClick: () => {
            _setPog(originalPog ? cloneDeep(originalPog) : null);
          },
        },
      ],
    });
  };

  const savePogAsOriginal = (savedPog: PogNonCircular | null = pog?.toNonCircular() ?? null) => {
    if (!savedPog) return;

    setOrignalPog(cloneDeep(new Pog(savedPog)));
  };

  const isModified = () => {
    return (
      originalPog !== null &&
      !isEqual(pog ? { ...pog.toNonCircular(), metrics: null } : null, {
        ...originalPog.toNonCircular(),
        metrics: null,
      })
    );
  };

  return {
    revertPog,
    setPog,
    savePogAsOriginal,
    pog,
    isModified: isModified(),
  };
};
